import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EuropassLogo from '../assets/images/logos/europass.svg';
import { downloadEdciFile } from '../utils/download.js';
import { LoadOrganization } from '../utils/queries.js';

export default function EdciDownload({ certificate, enabled, onExpiredToken }) {
    const { t } = useTranslation();

    const organization = LoadOrganization(certificate?.minter).data;

    const handleClickDownloadEdci = () =>
        downloadEdciFile(certificate.id, certificate.image, certificate.minter, onExpiredToken, organization);

    return (
        <>
            {enabled && (
                <Stack>
                    <Stack direction={'row'} paddingTop={1} paddingBottom={1}>
                        <Stack justifyContent={'center'} paddingLeft={1}>
                            <img height={'22px'} width={'22px'} src={EuropassLogo} alt="Europass" />
                        </Stack>
                        <Stack marginLeft={1}>
                            <Typography variant="body2" pr={1}>
                                <Link className={'cursor-pointer'} onClick={handleClickDownloadEdci}>
                                    {t('certificate.europass_download_1')}
                                </Link>
                                {t('certificate.europass_download_2')}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
            {!enabled && (
                <Stack>
                    <Stack
                        direction={'row'}
                        paddingTop={1}
                        paddingBottom={1}
                        sx={{
                            backgroundColor: '#F6F6F6',
                            borderRadius: '16px',
                        }}
                    >
                        <Stack justifyContent={'center'} paddingLeft={1}>
                            <img height={'22px'} width={'22px'} src={EuropassLogo} alt="Europass" />
                        </Stack>
                        <Stack marginLeft={1}>
                            <Typography variant="body2" pr={1}>
                                {t('certificate.europass_disabled')}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </>
    );
}
